
const API_HOST=process.env.REACT_APP_API_URL;
const API_BASE="/api"
const VERSION_V1="/v1"

const SOUNDBOX_HOST= process.env.REACT_APP_SOUNDBOX_HOST_URL;

const V1ENDPOINT= `${SOUNDBOX_HOST}${API_BASE}`
const SMART_LOCK_HOST= process.env.REACT_APP_SMART_LOCK_HOST;


export const API_ENDPOINTS={
    "GET_USERS":V1ENDPOINT.concat("/v1/b2b/users"),
    "GET_LOCATIONS":V1ENDPOINT.concat("/v1/b2b/admin/locations"),
    "ADD_NEW_LOCATION":V1ENDPOINT.concat("/v1/b2b/admin/location"),
    "LOCATION_BULK_UPLOAD":V1ENDPOINT.concat("/v1/b2b/locations/bulk-upload"),
    "USERS_BULK_UPLOAD":V1ENDPOINT.concat("/v1/b2b/users/bulk-upload"),
    "USER_DETAILS":V1ENDPOINT.concat("/v1/b2b/user"),
    "CREATE_USER":V1ENDPOINT.concat("/v1/b2b/user"),
    "ADD_USER_DEVICE":V1ENDPOINT.concat("/v1/b2b/user/device"),
    "REMOVE_USER_DEVICE":V1ENDPOINT.concat("/v1/b2b/user/device"),
    "DOWNALOD_USER_SAMPLE_EXCEL":V1ENDPOINT.concat("/v1/b2b/users/bulk-upload/sample"),
    "SEND_VIDEO_CALL_REQUEST":V1ENDPOINT.concat("/v1/b2b/admin/video-call"),
    "GET_WAREHOUSE_ORDERS":V1ENDPOINT.concat("/v1/b2b/warehouse/orders"),
    "GET_WAREHOUSE_ORDER_SCAN_STATS":V1ENDPOINT.concat("/v1/b2b/warehouse/order-item-scans/stats"),
    "ORDER_DETAILS":V1ENDPOINT.concat("/v1/b2b/warehouse/order"),
    "GET_MY_VIDEO_CALLS":V1ENDPOINT.concat("/v1/b2b/user/<user_id>/video-calls"),
    "GET_ADMIN_VIDEO_CALLS":V1ENDPOINT.concat("/v1/b2b/admin/video-calls"),
    "GET_MY_CALL_IMAGES":V1ENDPOINT.concat("/v1/b2b/video-call/<video_call_id>/media/images"),
    "GET_MY_CALL_VIDEOS":V1ENDPOINT.concat("/v1/b2b/video-call/<video_call_id>/media/videos"),
    "GET_DEVICE_VIDEOS":V1ENDPOINT.concat("/v1/b2b/device/<device_id>/video-recordings"),
    "GET_STREAM_IMAGE_UPLOAD_URL":V1ENDPOINT.concat("/v1/b2b/video-call/<video_call_id>/media/image/upload-link"),
    "GET_STREAM_VIDEO_UPLOAD_URL":V1ENDPOINT.concat("/v1/b2b/video-call/<video_call_id>/media/video/upload-link"),
    "ADMIN_SIGNUP":V1ENDPOINT.concat("/v1/b2b/admin/signup"),
    "ADMIN_SIGNIN":V1ENDPOINT.concat("/v1/b2b/admin/signin"),
    "ADMIN_SIGNOUT":V1ENDPOINT.concat("/v1/b2b/admin/signout"),
    "GET_B2B_LOCATIONS":V1ENDPOINT.concat("/v1/b2b/users/devices-gps-locations"),
    "ADMIN_COGNITION_SESSION":V1ENDPOINT.concat("/v1/b2b/admin/cognito/session"),
    "GET_SCANNER_EVENTS_DATA":V1ENDPOINT.concat("/v1/b2b/devices/scanner-events"),
    "GET_ADMIN_LOCATION_HISTORY":V1ENDPOINT.concat("/v1/b2b/user/<user_id>/gps-location/history"),
    "GET_ADMIN_LOCATION_TIMELINE":V1ENDPOINT.concat("/v1/b2b/user/<user_id>/gps-location/timeline"),
    "GET_ADMIN_NOTIFICATION_HISTORY":V1ENDPOINT.concat("/v1/b2b/admin/notifications"),
    "GET_STATE_LIST":V1ENDPOINT.concat("/v1/b2b/admin/states"),
    "GET_CITY_LIST":V1ENDPOINT.concat("/v1/b2b/admin/cities"),
    "GET_USER_SENSOR_HISTORY":V1ENDPOINT.concat("/v1/b2b/user/device-sensors-data/history"),
    "GET_ADMIN_DASHBOARD_DATA":V1ENDPOINT.concat("/v1/b2b/admin/dashboard/content")
    
}


 export const SOUNDBOX_API_ENDPOINTS={

    // MFA is enabled only for BOB and its endpoint varies from that of commonDashboard. Hence different API endpoints
    ADMIN_SIGN_IN: process.env.REACT_APP_ENVIRONMENT === "common_dashboard" 
    ? '/auth/admin/email/login/' 
    : '/auth/admin/login/',
    ADMIN_SIGN_OUT:'/auth/logout',
    FORGET_PASSWORD:'/auth/forgotpassword',
    RESET_PASSWORD:'/auth/resetpassword',
    ADMIN_VALIDATE_LOGIN_OTP:'/auth/admin/email/login/validateotp',
    

    DEVICE_LIST:'/devices/',
    GET_DEVICE_BY_ID:'/devices/getDeviceDetails',
    GET_MERCHANT_LIST:'/merchants/getMerchantListnew',
    ADD_NEW_MERCHANT:'/merchants',

    GET_MERCHANT_HEARTBEAT_BY_SHADOW:"/shadow?shadow=status&IMEI=",
    GET_MERCHANT_ONLINE_STATUS:"/shadow?shadow=presence&IMEI=",


    CREATE_ORGANIZATION:'/organizations',
    GET_ORGANIZATION_LIST:'/organizations',
    CREATE_USER_IN_ORGANIZATION:'/users',
    REACTIVATE_USER_IN_ORGANIZATION:'/users/reactivate',


    SETUP_ORGANIZATION_CONFIG:'/organizations/setUpOrg',
    MERCHANT_BULK_UPLOAD:'/merchants/onboardMerchants',
    ORG_BRANCHES_BULK_UPLOAD:'/merchants-services-area',
    APP_SETTINGS:'/app-settings',
    TERRITORIES_STRUCTURE:'/territories/getTerritoryStructure/<orgId>',
    DASHBOARD_STATS:'/device-inventories/dashboardStats',
    TRANSACTION_STATS:'/device-inventories/dashboardSummary',
    TRANSATION_LIST:'/payments',
    GET_DEVICE_TRANSACTION:'/payments/paymentTransactionByDeviceId',
    DEVICE_LIST_WITH_TRANS:'/devices/getDeviceList',
    DEVICE_REBOOT_REQUEST:'/events/RequestByServer',
    NOTIFICATION_HISTORY:'/device-inventories/getNotification',
    GET_DEVICE_PAYLOAD_USING_IMEI:'/productionapp/getdata/',
    PUSH_PAYMENT_TO_DEVICE:'/mqtt-broker/send-command',
    SAVE_TEST_RESULT:'/productionapp/savetestresult',
    CREATE_DEVICE_IN_INVENTORY:'/device-inventories',
    EXPORT_MERCHANT_REPORT:'/merchants/downloadMerchantData',
    EXPORT_TRANSACTION_REPORT:'/payments/downloadTransactionData?cumulative=true',
    ACTIVATE_DEVICE_TO_MERCHANT:"/agents",
    REMOVE_DEVICE_FROM_MERCHANT:"/agents/deActive",

    FETCH_DEVICE_DETAILS:'/devices/',


    CREATE_PROCURED_DEVICE_IN_INVENTORY:'/device-inventories/createCWDDevice',
    REQUEST_ON_DEMAND_DEVICE_STATUS:'/device-inventories/requestForOnDemandDeviceStatus',
    GET_ON_DEMAND_DEVICE_STATUS_DATA:'/device-inventories/getOnDemandDeviceStatus',

    GET_DEVICE_PAYMENT_STATS: '/payments/stats',


 }

export const randomClientIdForSession= 'web_client_'.concat(process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID).concat("_").concat(Math.random()
        .toString(36)
        .substring(2)
        .toUpperCase());


export const IOT_NOTIFICATION_EVENTS={
    FLAMMABLE_GAS_DETECTED_ALERT: "FLAMMABLE_GAS_DETECTED_ALERT",
    FLAMMABLE_GAS_SENSOR_ERROR: "FLAMMABLE_GAS_SENSOR_ERROR",
    DEVICE_FALL_ALERT: "DEVICE_FALL_ALERT",
    DEVICE_PROXIMITY_ALERT: "DEVICE_PROXIMITY_ALERT",
    DEVICE_SCANNER_DATA:"SCANNER_DATA",
    DEVICE_BATTERY_LOW_ALERT:"DEVICE_BATTERY_LOW_ALERT"
}

export const APP_CONSTANTS={
    L_KEY_OF_USER_DATA : "puad",
    L_KEY_OF_USER_IOT_CLIENT_ID : "padiotc",
    L_KEY_OF_USER_LOGGEDIN_STATUS : "isLoggedin",
    L_KEY_OF_USER_ADMIN_SSOTOKEN : "sso-token",
    L_KEY_OF_USER_ADMIN_COGNIO_CRED : "cgntCred",
    L_KEY_OF_P_DASHBOARD:"P_DASHB",

    API_SUCCESS_ACTION:'API_SUCCESS_ACTION',
    API_FAILURE_ACTION:'API_FAILURE_ACTION',
    API_INPROGRESS_ACTION:'API_INPROGRESS_ACTION',

    USER_ROLE_SUPER_ADMIN:"superadmin",
    USER_ROLE_ADMIN:"admin",
    USER_ROLE_CHECKER:"checker",
    USER_ROLE_MAKER:"maker",


    MERCHANT_EXPORT_REPORT:"MERCHANT_EXPORT_REPORT",
    TRANSACTION_EXPORT_REPORT:"TRANSACTION_EXPORT_REPORT",
    RENT_STATUS_EXPORT_REPORT:"RENT_STATUS_EXPORT_REPORT",

    L1_SUPPORT_USER_ROLE:'support_1',
    L2_SUPPORT_USER_ROLE:'support_2',

    ADD_DEVICE_MERCHANT_ACTION:'ADD_DEVICE_MERCHANT_ACTION',
    REMOVE_DEVICE_MERCHANT_ACTION:'REMOVE_DEVICE_MERCHANT_ACTION',

    BOI_ORGANIZATION_IDENTIFIER: "BOI",
    BOB_ORGANIZATION_IDENTIFIER: "BOB",
    AIRTEL_ORGANIZATION_IDENTIFIER: "APB",
    MAXIMUS_ORGANIZATION_IDENTIFIER: "MXS",
    SWINKPAY_ORGANIZATION_IDENTIFIER: "SWP",



    CUSTOM_ERROR_CODES:{

        PASSWORD_EXPIRED: "40089"
    }


}



export const SOUNDBOX_APP_CONSTANTS={
    L_KEY_OF_COGNITO_TOKEN:"cogtokl"
}

export const ONGOING_VIDEO_CALL_DATA={
    "id":"no_data",
    "userData":[]
}

export const LOGGEDIN_USER_DATA={
    profile:{},
    clientId:""
}
